import type { CurrentAccountSettingsDetailsConfig } from '@shared/products-feature-configs';

export const settingsDetails: CurrentAccountSettingsDetailsConfig = {
    displayAccountOwner: false,
    displayBalance: false,
    displayCancelledState: false,
    displayCreationDate: false,
    displayClosingDate: false,
    displayDebitInterestAccrued: false,
    displayDebitInterestRate: false,
    displayDebitInterestRatePeriod: false,
    displayCreditInterestRateToDate: false,
    displayCreditInterestRatePeriod: false,
    displayDirectDebit: false,
    displayDisposable: false,
    displayFeesAccrued: false,
    displayOverdraft: false,
    displayFees: false,
    displayOverdraftApprovedLimit: false,
    displayOverdraftClientLimit: false,
    displayOverdraftDateSpan: false,
    displayOverdraftDueDate: false,
    displayOwnResources: false,
    displayRoUsedOverdraft: false,
    displaySecondaryIdManagement: false,
    displayBIC: false,
    displayBICForFxAccount: false,
    displayDashedBBAN: false,
    displayIBAN: false,
    displayIBANForFxAccount: false,
    displayPlainAccountNumber: false,
    displaySpacedBBAN: false,
    displaySlashedBBAN: false,
    showDetailedOverdraftBox: false,
    approvedOverdraftLabel: 'account.overdraft.overdraftLabel',
    overdraftLabel: 'account.overdraft.overdraftLabel',
    shouldHideOverdraftAmountRow: false,
    shouldHideSeparatedBalance: false,
    showAccountProhibitions: false,
    displayTurnoverProvision: false,
    displayPenaltyInterestRate: false,
    disableBICCopyAction: false,
    subtypeDependentAccountNumberCopyAction: false,
};
